module.exports = __webpack_public_path__ + "img/Desk_shelf(jetstation).83fe54d2.png";